import * as React from 'react';
import { AppSettings } from '../../utils/app-settings';
import './EnvironmentBadge.scss';

// Whether the badge is showing, which it is whenever we know what environment this is
export const hasEnvironmentBadge = () : boolean => {
    return (AppSettings._clientEnv && AppSettings._clientEnv.length > 0) ? true : false;
};

// What the badge says: the name of the environment as it is configured, except that localhost is DEV, which is shorter
export const environmentLabel = (environment : string) : string => {
    return environment.toLowerCase() === 'localhost' ? 'DEV' : environment;
};

// The name of the environment, as a pill in the top bar
export const EnvironmentBadge = () => {

    const hasEnv = hasEnvironmentBadge();

    return hasEnv ? <div className={`environment-badge ${ AppSettings._clientEnv }`}>
            { environmentLabel(AppSettings._clientEnv) }
        </div> : null;
};

// A strip across the top of the window, which stays in view when the page scrolls, so that it is never in doubt which
// environment this is
export const EnvironmentStrip = () => {

    const hasEnv = hasEnvironmentBadge();

    return hasEnv ? <div className={`environment-strip ${ AppSettings._clientEnv }`} aria-hidden="true" /> : null;
};
